var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB-JOB1/src/components/Divider/Divider.js",
  _this = this;
import React from 'react';
import styled, { css } from 'styled-components';
import { withTheme } from '../../core/ThemeProvider';
var StyledDivider = withTheme(styled.div.withConfig({
  displayName: "Divider__StyledDivider",
  componentId: "sc-1qi29z9-0"
})(["box-sizing:border-box;margin:0;padding:0;", ";"], function (_ref) {
  var coreTheme = _ref.coreTheme,
    type = _ref.type;
  switch (type) {
    case 'horizontal':
      return css(["display:flex;clear:both;width:100%;min-width:100%;border-top:1px solid ", ";"], coreTheme.cl_divider);
    case 'vertical':
      return css(["display:flex;clear:both;min-height:100%;border-left:1px solid ", ";"], coreTheme.cl_divider);
    default:
      break;
  }
}));
export var Divider = function Divider(props) {
  return /*#__PURE__*/React.createElement(StyledDivider, {
    type: props.type,
    "data-testid": props['data-testid'],
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 10
    }
  });
};
Divider.defaultProps = {
  type: 'horizontal'
};
export default Divider;